import { render, staticRenderFns } from "./card-grid-with-controls.vue?vue&type=template&id=35bdcfe2&scoped=true&"
import script from "./card-grid-with-controls.vue?vue&type=script&lang=js&"
export * from "./card-grid-with-controls.vue?vue&type=script&lang=js&"
import style0 from "./card-grid-with-controls.vue?vue&type=style&index=0&id=35bdcfe2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bdcfe2",
  null
  
)

export default component.exports